export default [
  // App启动配置
  {
    path: 'app-starup-configure',
    name: 'AppStarUpConfigure',
    meta: {
      isDynamic: true,
      id: 'App启动页配置', // 11
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "AppStarUpConfigure" */ '@/views/Content/AppStarUpConfigure/AppStarUpConfigure.vue'
      )
  },
  {
    path: 'carousel-configure',
    name: 'CarouselConfigure',
    meta: {
      isDynamic: true,
      id: '轮播图配置', // 12
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "CarouselConfigure" */ '@/views/Content/CarouselConfigure/CarouselConfigure.vue'
      )
  },
  {
    path: 'platform-notice',
    name: 'PlatformNotice',
    meta: {
      isDynamic: true,
      id: '平台公告资讯', // 13
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "PlatformNotice" */ '@/views/Content/PlatformNotice/PlatformNotice.vue'
      )
  }
];
